import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { withStyleProxy } from '../../higher_order_components/with_style_proxy';
import { getContent } from '../utils';

import * as actions from './actions';
import { shapedPropsWarning } from '../../../ctm-util-functions';

/**
 * Anchor Component
 * @desc Anchor to generate the <a> tag
 * @returns {_Anchor}
 *
 * To redirect for internal routes, use our InternalLink component
 * Use <a> for other links (eg documents, external links, modals etc...)
 */
class _Anchor extends PureComponent {

    constructor(props) {
        super(props);
        // @todo remove once all shapedProps are gone
        shapedPropsWarning(props, 'Anchor');
    }

    /**
     * Handles the behaviour of the contextmenu event on a link, to open the mcafee page instead of context menu
     * @returns {Boolean} Returns true to continue opening the context menu and false to prevent it opening.
     */
    onContextMenuEvent = () => {
        const { onContextMenu } = this.props;
        if (actions[onContextMenu]) {
            return actions[onContextMenu].apply(this, [this.props]);
        }
        // allow right click.
        return true;
    };

    /**
     * Handles clicking on an anchor
     * @param {Event} event The elements event object
     */
    handleClick = (event) => {
        const { onClick, dispatch } = this.props;
        if (onClick) {
            if (typeof onClick === 'function') {
                onClick.call(this, event);
            } else if (onClick.actions) {
                onClick.actions.map((action) => dispatch(action));
            }
        }
        // If we got this far, the click will be handled by the browser (e.g. open external link)
    };

    render = () => {
        const { className, href = 'javascript:;', target, rel, id, title, 'data-id': dataId, tabIndex = 0 } = this.props;
        return (
            <a
                href={href}
                target={target}
                rel={rel}
                id={id}
                title={title}
                className={className}
                data-id={dataId}
                tabIndex={tabIndex}
                onClick={this.handleClick}
                onContextMenu={this.onContextMenuEvent}
            >
                {getContent(this.props)}
            </a>
        );
    };

}

_Anchor.propTypes = {
    className: PropTypes.string,
    // eslint-disable-next-line react/no-unused-prop-types
    label: PropTypes.string,
    // eslint-disable-next-line react/no-unused-prop-types
    icon: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.string,
    rel: PropTypes.string,
    id: PropTypes.string,
    title: PropTypes.string,
    'data-id': PropTypes.string,
    tabIndex: PropTypes.number,
    onContextMenu: PropTypes.string,
    onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    dispatch: PropTypes.func
};

_Anchor.defaultProps = {
    label: null,
    icon: null,
    href: '#!'
};

export { _Anchor };
// connect is required so we can get dispatch on the eventProps
export const Anchor = withStyleProxy(connect()(_Anchor));
